import { render } from "./CoachesList.vue?vue&type=template&id=1292248a&scoped=true"
import script from "./CoachesList.vue?vue&type=script&lang=js"
export * from "./CoachesList.vue?vue&type=script&lang=js"

import "./CoachesList.vue?vue&type=style&index=0&id=1292248a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1292248a"]])

export default __exports__